import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type ViewAssignmentsQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
  start: Types.Scalars['timestamptz']['input'];
  end: Types.Scalars['timestamptz']['input'];
  limit: Types.Scalars['Int']['input'];
}>;


export type ViewAssignmentsQuery = { __typename?: 'query_root', moves: Array<{ __typename?: 'moves', id: number, scenariotomoves: Array<{ __typename?: 'scenariotomoves', id: number, scenario: { __typename?: 'scenarios', id: number, scenario_key: string, moves: Array<{ __typename?: 'scenariotomoves', id: number, cardinality: number, move: { __typename?: 'moves', id: number, move_type: string, active: number, lite: boolean, status?: string | null, parent_move_id?: number | null, driver_id?: number | null, driver_name?: string | null, consumer_name?: string | null } }>, bundletoscenarios: Array<{ __typename?: 'bundletoscenarios', id: number, bundle: { __typename?: 'bundles', id: number, offers: Array<{ __typename?: 'offers', id: number, status: string, offered_at?: string | null, offered_by?: string | null, accepted_at?: string | null, accepted_by?: string | null, createdat: string, createdby: string, updatedat: string, updatedby: string, driver: { __typename?: 'drivers', id: number, user?: { __typename?: 'users', id: number, display_name: string, avatar_url?: string | null } | null } }> } }> } }> }> };


export const ViewAssignmentsDocument = gql`
    query viewAssignments($customerId: bigint!, $start: timestamptz!, $end: timestamptz!, $limit: Int!) {
  moves(
    where: {active: {_eq: 1}, move_type: {_eq: "drive"}, _and: [{_or: [{customer_id: {_eq: $customerId}}, {payer_id: {_eq: $customerId}}]}, {_or: [{pickup_time: {_gte: $start, _lte: $end}}, {ready_by: {_gte: $start, _lte: $end}}]}]}
    order_by: [{ready_by: asc}, {id: asc}]
    limit: $limit
  ) {
    id
    scenariotomoves(
      where: {scenario: {status: {_neq: "deprecated"}}}
      order_by: {scenario: {createdat: desc}}
      limit: 1
    ) {
      id
      scenario {
        id
        scenario_key
        moves(order_by: {cardinality: asc}) {
          id
          cardinality
          move {
            id
            move_type
            active
            lite
            status
            parent_move_id
            driver_id
            driver_name
            consumer_name
          }
        }
        bundletoscenarios(
          where: {bundle: {status: {_in: ["ready", "dispatching", "dispatched"]}}}
          order_by: {id: desc}
        ) {
          id
          bundle {
            id
            offers(
              where: {status: {_in: ["offered", "accepted", "assigned"]}}
              order_by: {id: desc}
            ) {
              id
              status
              offered_at
              offered_by
              accepted_at
              accepted_by
              createdat
              createdby
              updatedat
              updatedby
              driver {
                id
                user {
                  id
                  display_name
                  avatar_url
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useViewAssignmentsQuery__
 *
 * To run a query within a React component, call `useViewAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewAssignmentsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useViewAssignmentsQuery(baseOptions: Apollo.QueryHookOptions<ViewAssignmentsQuery, ViewAssignmentsQueryVariables> & ({ variables: ViewAssignmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewAssignmentsQuery, ViewAssignmentsQueryVariables>(ViewAssignmentsDocument, options);
      }
export function useViewAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewAssignmentsQuery, ViewAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewAssignmentsQuery, ViewAssignmentsQueryVariables>(ViewAssignmentsDocument, options);
        }
// @ts-ignore
export function useViewAssignmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewAssignmentsQuery, ViewAssignmentsQueryVariables>): Apollo.UseSuspenseQueryResult<ViewAssignmentsQuery, ViewAssignmentsQueryVariables>;
export function useViewAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewAssignmentsQuery, ViewAssignmentsQueryVariables>): Apollo.UseSuspenseQueryResult<ViewAssignmentsQuery | undefined, ViewAssignmentsQueryVariables>;
export function useViewAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewAssignmentsQuery, ViewAssignmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewAssignmentsQuery, ViewAssignmentsQueryVariables>(ViewAssignmentsDocument, options);
        }
export type ViewAssignmentsQueryHookResult = ReturnType<typeof useViewAssignmentsQuery>;
export type ViewAssignmentsLazyQueryHookResult = ReturnType<typeof useViewAssignmentsLazyQuery>;
export type ViewAssignmentsSuspenseQueryHookResult = ReturnType<typeof useViewAssignmentsSuspenseQuery>;
export type ViewAssignmentsQueryResult = Apollo.QueryResult<ViewAssignmentsQuery, ViewAssignmentsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/viewAssignments/queries/viewAssignments.query.gql}
 */
export async function viewAssignments(
  variables: ViewAssignmentsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<ViewAssignmentsQuery['moves']>
export async function viewAssignments(
  variables: ViewAssignmentsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<ViewAssignmentsQuery>
export async function viewAssignments(
  variables: ViewAssignmentsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<ViewAssignmentsQuery['moves'] | ViewAssignmentsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<ViewAssignmentsQuery>(
    ViewAssignmentsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.moves
}